export default {
  forget: "فراموشی رمز عبور",
  forgetCm: "شماره تلفن همراه خود را وارد کنید. رمز جدید پیامک خواهد شد.",
  mobile: "شماره تلفن همراه",
  send: "ارسال",
  login: "بازگشت به صفحه ورود",
  enterMobile: "لطفا شماره تلفن همراه را وارد کنید.",
  enterPassword: "لطفا کلمه عبور را وارد کنید.",
  invalidAdmin: "نام کاربری یا کلمه عبور نامعتبر است!"

}
